import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Navbar.css';
import { FaHome, FaInfoCircle, FaUserShield, FaCalendarAlt, FaSignOutAlt, FaSignInAlt, FaUserPlus, FaGamepad, FaCaretDown } from 'react-icons/fa';

function Navbar({
  isAdminLoggedIn,
  setIsAdminLoggedIn,
  isNavbarVisible,
}) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isInfoDropdownOpen, setIsInfoDropdownOpen] = useState(false); // State for "Info" dropdown
  const [isExtrasDropdownOpen, setIsExtrasDropdownOpen] = useState(false); // State for "Extras" dropdown

  const handleLogout = () => {
    localStorage.removeItem('isAdminLoggedIn');
    setIsAdminLoggedIn(false);
    navigate('/');
    setIsMenuOpen(false);
  };

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavigate = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  const toggleInfoDropdown = () => {
    setIsInfoDropdownOpen(!isInfoDropdownOpen);
  };

  const toggleExtrasDropdown = () => {
    setIsExtrasDropdownOpen(!isExtrasDropdownOpen);
  };

  return (
    <div>
      {isNavbarVisible ? (
        <nav className="navbar">
          <div className="navbar-logo">
            <img
              src="/images/buzzboard.jpg"
              alt="Buzz Board Logo"
              className="buzz"
            />
          </div>
          <div className="powered-by-container">
            <div className="powered-by-logo">
              <img
                src="/images/power.jpg"
                alt="Powered By Logo"
                style={{ width: '150px', height: 'auto' }}
                className="power"
              />
            </div>
            <a href="https://www.kandmsales.net" target="_blank" rel="noopener noreferrer">
              <img
                src="/images/kmlogo.png"
                alt="Powered By Logo"
                className="powered-by-logo"
              />
            </a>
          </div>
          <button className="menu-button" onClick={handleMenuToggle}>
            ☰
          </button>
          <div className={`navbar-links ${isMenuOpen ? 'open' : ''}`}>
            <button onClick={() => handleNavigate('/')} className="navbar-button">
              <FaHome style={{ marginRight: '8px' }} /> Home
            </button>

            {/* Info Dropdown */}
            <div
              className="dropdown"
              onMouseEnter={() => setIsInfoDropdownOpen(true)}
              onMouseLeave={() => setIsInfoDropdownOpen(false)}
            >
              <button onClick={toggleInfoDropdown} className="navbar-button dropdown-button">
                <FaInfoCircle style={{ marginRight: '8px' }} /> Info <FaCaretDown />
              </button>
              <div className={`dropdown-menu ${isInfoDropdownOpen ? 'open' : ''}`}>
                <button onClick={() => handleNavigate('/about')} className="dropdown-item">
                  About
                </button>
                <button onClick={() => handleNavigate('/pricing')} className="dropdown-item">
                  Pricing
                </button>
                <button onClick={() => handleNavigate('/flash')} className="dropdown-item">
                  Buzz Board FLA⚡H
                </button>
              </div>
            </div>

            {/* Extras Dropdown */}
            <div
              className="dropdown"
              onMouseEnter={() => setIsExtrasDropdownOpen(true)}
              onMouseLeave={() => setIsExtrasDropdownOpen(false)}
            >
              <button onClick={toggleExtrasDropdown} className="navbar-button dropdown-button">
                <FaGamepad style={{ marginRight: '8px' }} /> Extras <FaCaretDown />
              </button>
              <div className={`dropdown-menu ${isExtrasDropdownOpen ? 'open' : ''}`}>
                {isAdminLoggedIn ? (
                  <>
                    <button onClick={() => handleNavigate('/bingo-machine')} className="dropdown-item">
                      Bingo Flashboard
                    </button>
                  </>
                ) : (
                  <button onClick={() => handleNavigate('/admin-login')} className="dropdown-item">
                    Login to access Extras
                  </button>
                )}
              </div>
            </div>

            {isAdminLoggedIn ? (
              <>
                <button onClick={() => handleNavigate('/admin')} className="navbar-button">
                  <FaUserShield style={{ marginRight: '8px' }} /> Admin Dashboard
                </button>
                <button onClick={() => handleNavigate('/events')} className="navbar-button">
                  <FaCalendarAlt style={{ marginRight: '8px' }} /> My Events
                </button>
                <button onClick={handleLogout} className="navbar-button">
                  <FaSignOutAlt style={{ marginRight: '8px' }} /> Logout
                </button>
              </>
            ) : (
              <>
                <button onClick={() => handleNavigate('/admin-login')} className="navbar-button">
                  <FaSignInAlt style={{ marginRight: '8px' }} /> Login
                </button>
                <button onClick={() => handleNavigate('/signup')} className="navbar-button">
                  <FaUserPlus style={{ marginRight: '8px' }} /> Signup
                </button>
              </>
            )}
          </div>
        </nav>
      ) : null}

    </div>
  );
}

export default Navbar;
